<script>
import AccordionTitle from './AccordionTitle'
import AccordionBody from './AccordionBody'
import AccordionDivider from './AccordionDivider'

export default {
  name: 'Accordion',
  components: {
    AccordionTitle,
    AccordionBody,
    AccordionDivider
  },
  props: {
    scale: {
      type: Number,
      default: 1
    },
    items: {
      type: Array,
      required: true
    },
    titleColor: {
      type: String,
      default: 'black'
    },
    contentColor: {
      type: String,
      default: 'black'
    }
  }
}
</script>

<template>
  <div class="container">
    <AccordionDivider
      :color="titleColor"
      :scale="scale"
    />
    <div
      v-for="item in items"
      :key="item.title"
    >
      <AccordionTitle
        :scale="scale"
        :color="titleColor"
        :title="item.title"
        @click.native="() => $refs[item.title][0].animate()"
      />
      <AccordionBody
        :ref="item.title"
        :scale="scale"
        :color="contentColor"
        :content="item.content"
      />
      <AccordionDivider
        :color="titleColor"
        :scale="scale"
      />
    </div>
  </div>
</template>
